import React, { useEffect, useState } from "react";
import { TextField, Button, FormHelperText } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  yourProfileDetailsAPICall,
  startOverAPICall,
  stageDetailsAPICall,
  CommonDropDownAPICall,
} from "../shared/APICalls";
import { IYourProfileDetails, IYourProfilePrefillData } from "../shared/dtos";
import routesData from "../shared/routes.json";
import ProfileStyles from "../pages/Styles/YourProfile.module.scss";
import BackDrop from "../Components/BackDrop";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/profileicongrey.svg";
import CommonDropdown from "../Components/SelectDropdown/CommonDropDown";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import { useDispatch } from "react-redux";
import PloiticalModal from "../Components/Modals/PoliticalModal/PoliticalModal";
import TagManager from "react-gtm-module";
import ProgressComp from "../Components/ProgressComp/ProgressComp";
import CommonDropdownLatest from "../Components/SelectDropdown/CommonDropDownLatest";
import CommonRadioGroup from "../Components/SelectDropdown/CommonRadioGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { isMobile } from "react-device-detect";

const schema = Yup.object().shape({
  fatherFullName: Yup.string()
    .required("Father Name is Required")
    .min(3, "Minmum 3 letters is required")
    .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .max(50)
    .transform((value: any) => value && value.toUpperCase()),
  motherFullName: Yup.string()
    .required("Mother Name is Required")
    .max(50)
    .min(3, "Minmum 3 letters is required")
    .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .transform((value: any) => value && value.toUpperCase()),
  annualIncome: Yup.object().required("Please select an option"),
  tradingExperience: Yup.object().required("Please select an option"),
  occupation: Yup.object().required("Please select an option"),
  occupationIfOthers: Yup.string()
    .nullable()
    .when("occupation", (occupation, schema) => {
      if (
        Array.isArray(occupation) &&
        occupation.length > 0 &&
        occupation[0]?.value === "Others"
      ) {
        return schema
          .required("Please Enter Occupation Others")
          .matches(/^[a-zA-Z ]*$/, "Enter a valid occupation")
          .min(3, "Minimum 3 letters are required")
          .max(50, "Maximum 50 characters allowed")
          .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed");
      }
      return schema.notRequired();
    }),

  areYouPoliticallyExposed: Yup.object().required("Please select an option"),
  maritalStatus: Yup.object().required("Marital Status is required"),
});

const maritalStatus = [
  {
    id: "single",
    sequence: 1,
    value: "Single",
  },
  {
    id: "married",
    sequence: 2,
    value: "Married",
  },
];
const politicallyExposed = [
  {
    id: "no",
    sequence: 1,
    value: "No",
  },
  {
    id: "yes",
    sequence: 2,
    value: "Yes",
  },
];

export default function YourProfilePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //Loaders
  const [loading, setloading] = useState(false);
  const [prefilloading, setprefilloading] = useState(true);
  const [occupationOther, setOthersDataFeild] = useState<any>();
  const [annualDropDownData, setAnnualDropDownData] = useState<any>([]);
  const [tradingExperienceDropdownData, settradingExperienceDropdownData] =
    useState<any>([]);
  const [occupationDropdownData, setoccupationDropdownData] = useState<any>([]);
  const [displayFatherNameField, setdisplayFatherNameField] =
    useState<any>(true);
  const [prefillData, setprefillData] = useState<IYourProfilePrefillData>({
    fatherFullName: "",
    motherFullName: "",
    annualIncome: "",
    tradingExperience: "",
    occupation: "",
    areYouPoliticallyExposed: "",
    maritalStatus: "",
    occupationIfOthers: "",
  });
  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [startOverloading, setstartOverloading] = useState(false);
  const [openModal, setopenModal] = useState(false);
  const [pastActions, setPastActions] = useState("");
  const [otherBrokers, setOtherBrokers] = useState("");
  const [expandOthers, setExpandOthers] = useState(false);
  const navigationData = routesData;

  function setOthersData(data: any) {
    // console.log(data);

    setOthersDataFeild(data);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);
    let annualFetchedData;
    let tradingFetchedData;
    let OccupationFetchedData;
    setprefilloading(true);
    let dd_type = "profile";
    CommonDropDownAPICall(dd_type)
      .then((response: any) => {
        const responseData = response.data.data;

        setAnnualDropDownData(
          responseData.annual_income
            .map((a: any) => {
              return a;
            })
            .sort((a: any, b: any) => a.sequence - b.sequence),
        );
        annualFetchedData = responseData.annual_income.map((a: any) => {
          return a;
        });

        settradingExperienceDropdownData(
          responseData.trading_exp
            .map((a: any) => {
              return a;
            })
            .sort((a: any, b: any) => a.sequence - b.sequence),
        );

        tradingFetchedData = responseData.trading_exp.map((a: any) => {
          return a;
        });
        setoccupationDropdownData(
          responseData.occupation.map((a: any) => {
            return a;
          }),
        );

        OccupationFetchedData = responseData.occupation.map((a: any) => {
          return a;
        });

        // API Call
        let obj: any = {
          stage: "customer_details",
        };

        stageDetailsAPICall(obj)
          .then((response: any) => {
            setprefilloading(false);

            const responseData = response.data;

            dispatch(setCompletedStages(responseData.data.completed_stages));
            dispatch(setCurrentStage(responseData.data.current_stage));
            const annualIncomeReturned = annualFetchedData.filter(
              (data: any) =>
                data.value === responseData.data.data.annual_income,
            )[0];
            const tradingExperienceReturned = tradingFetchedData.filter(
              (data: any) => data.value === responseData.data.data.trading_exp,
            )[0];
            const occupationReturned = OccupationFetchedData.filter(
              (data: any) =>
                data.value === responseData.data.data.occupation.occ_value,
            )[0];

            setRejectMessage(responseData.data.ErrorMessage);

            setOthersDataFeild(
              responseData.data.data.occupation.occ_value === "Others"
                ? "Others"
                : responseData.data.data.occupation.others_value,
            );
            setprefillData((prev) => {
              return {
                ...prev,
                fatherFullName: responseData.data.data.father_name,
                motherFullName: responseData.data.data.mother_name,
                annualIncome: annualIncomeReturned ? annualIncomeReturned : "",
                maritalStatus:
                  responseData.data.data.marital_status === "married"
                    ? maritalStatus[1]
                    : responseData.data.data.marital_status === "single"
                      ? maritalStatus[0]
                      : "",
                areYouPoliticallyExposed:
                  responseData.data.data.political_exposed === true
                    ? politicallyExposed[1]
                    : responseData.data.data.political_exposed === false
                      ? politicallyExposed[0]
                      : politicallyExposed[0],
                tradingExperience: tradingExperienceReturned
                  ? tradingExperienceReturned
                  : "",
                occupation: occupationReturned ? occupationReturned : "",
                occupationIfOthers:
                  responseData.data.data.occupation.others_value,

                // settlements: preferenceType ? preferenceType : Settlements[0],
              };
            });
          })
          .catch((error: any) => {
            setprefilloading(false);
            setdisplayFatherNameField(true);
            //  console.log("error", error);
          });
      })
      .catch((error: any) => {
        setprefilloading(false);
        // console.log("error", error);
      });
  }, []);

  const annualIncomeOptions = annualDropDownData;
  const tradingExperienceOptions = tradingExperienceDropdownData;
  const occupationOptions = occupationDropdownData;

  function yourProfile(data: any) {
    if (data.areYouPoliticallyExposed.id === "yes") {
      setopenModal(true);
    } else {
      TagManager.dataLayer({
        dataLayer: {
          event: "formSubmitProfile",
        },
      });
      setloading(true);
      let obj: IYourProfileDetails = {
        marital_status: data.maritalStatus.id,
        father_name: data.fatherFullName.toUpperCase(),
        mother_name: data.motherFullName.toUpperCase(),
        annual_income: data.annualIncome.value,
        trading_exp: data.tradingExperience.value,
        occupation: data.occupation.value,
        occupation_others:
          occupationOther === "Others"
            ? data.occupationIfOthers.toUpperCase()
            : "",
        politically_exposed: data.areYouPoliticallyExposed.id,
      };
      yourProfileDetailsAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          // console.log(responseData);
          setloading(false);
          if (
            responseData.data.next_stage &&
            navigationData.hasOwnProperty(responseData.data.next_stage)
          ) {
            navigate(navigationData[responseData.data.next_stage]);
          }
        })
        .catch((error: any) => {
          setloading(false);
        });
    }
  }

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            setstartOverloading(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                // console.log("responseData", response);
                setstartOverloading(false);
                setBackDrop(false);
                navigate("/");
                window.location.reload();
              })
              .catch((error: any) => {
                setBackDrop(false);
                setstartOverloading(false);
              });
          },
        },
      ],
    });
  };
  const initialValues: IYourProfilePrefillData = {
    fatherFullName: prefillData.fatherFullName,
    motherFullName: prefillData.motherFullName,
    annualIncome: prefillData.annualIncome,
    tradingExperience: prefillData.tradingExperience,
    occupation: prefillData.occupation,
    areYouPoliticallyExposed: prefillData.areYouPoliticallyExposed,
    maritalStatus: prefillData.maritalStatus,
    occupationIfOthers:
      prefillData.occupationIfOthers === null
        ? ""
        : prefillData.occupationIfOthers,
    // settlements: prefillData.settlements,
  };

  const handleDone = () => {
    setopenModal(false);
  };

  // console.log("occupationOther", occupationOther);

  return (
    <>
      {/* <div className={ProfileStyles.step}>
        <img src={keyboardicon} /> Step 1 of 4
      </div> */}
      <ProgressComp />
      <div className={ProfileStyles.mainWrapper}>
        {/* <StageLayoutEkyc
        completedStages={completedStages}
        stageName={"Personal Details"}
        navigatePath={"/aadhaarkyc"}
      /> */}
        <>
          <div className={ProfileStyles.wrapper}>
            {/* <div className={ProfileStyles.step}>
              <img src={keyboardicon} /> Step 3 of 10
            </div> */}
            <div className={ProfileStyles.leftContainer}>
              <div className={ProfileStyles.headerSection}>
                <p className={ProfileStyles.signup}>
                  Share A Bit About Yourself
                </p>
              </div>
              {!prefilloading ? (
                <Formik
                  validationSchema={schema}
                  initialValues={initialValues}
                  onSubmit={(values: any) => {
                    // console.log("values", values);
                    yourProfile(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  }) => {
                    // console.log("values", values);
                    // console.log("errors", errors);
                    return (
                      <form
                        autoComplete="off"
                        noValidate
                        onSubmit={handleSubmit}
                        onKeyDown={(event) => {
                          event.code === "Enter" && handleSubmit();

                          // event.code.includes("Enter") && handleSubmit()
                        }}
                      >
                        <div className={ProfileStyles.contentWrapper}>
                          <div className={ProfileStyles.topContainer}>
                            <div className={ProfileStyles.textFeildWrapper}>
                              <div className={ProfileStyles.labeltext}>
                                Father's Name
                              </div>
                              {displayFatherNameField && (
                                <TextField
                                  autoComplete="new-password"
                                  className={ProfileStyles.textfield}
                                  id="outlined-basic"
                                  // label="Father's Name"
                                  placeholder="Father's Name"
                                  variant="outlined"
                                  name="fatherFullName"
                                  value={
                                    values.fatherFullName &&
                                    values.fatherFullName.toUpperCase()
                                  }
                                  error={
                                    touched.fatherFullName &&
                                    Boolean(errors.fatherFullName)
                                  }
                                  helperText={
                                    touched.fatherFullName &&
                                    errors.fatherFullName?.toString()
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  inputProps={{
                                    sx: {
                                      "&::label": {
                                        fill: "#111827",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                      },
                                      color: "#121923",
                                      fontSize: "14px",
                                      "&::placeholder": {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        opacity: 0.6,
                                      },
                                    },
                                    maxLength: 50,
                                    inputMode: "text",
                                    form: {
                                      autoComplete: "off",
                                    },
                                  }}
                                  sx={{
                                    fieldset: {
                                      borderColor: "#E5E7EB",
                                      borderRadius: "100px",
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      color: "#6B7280",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      // marginTop:"2px",
                                      "&.MuiFormLabel-filled": {
                                        color: "#111827",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        fontFamily: "inherit",
                                      },
                                    },
                                  }}
                                />
                              )}
                            </div>

                            <div className={ProfileStyles.textFeildWrapper}>
                              <div className={ProfileStyles.labeltext}>
                                Mother's Name
                              </div>
                              <TextField
                                autoComplete="new-password"
                                className={ProfileStyles.textfield}
                                id="outlined-basic"
                                // label="Mother's Name"
                                placeholder="Mother's Name"
                                variant="outlined"
                                name="motherFullName"
                                value={
                                  values.motherFullName &&
                                  values.motherFullName.toUpperCase()
                                }
                                error={
                                  touched.motherFullName &&
                                  Boolean(errors.motherFullName)
                                }
                                helperText={
                                  touched.motherFullName &&
                                  errors.motherFullName?.toString()
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={{
                                  sx: {
                                    "&::label": {
                                      fill: "#111827",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                    },
                                    color: "#121923",
                                    fontSize: "14px",
                                    "&::placeholder": {
                                      color: "#6B7280",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      opacity: 0.6,
                                    },
                                  },
                                  maxLength: 50,
                                  inputMode: "text",
                                  form: {
                                    autoComplete: "off",
                                  },
                                }}
                                sx={{
                                  fieldset: {
                                    borderColor: "#E5E7EB",
                                    borderRadius: "100px",
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: "#6B7280",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    "&.MuiFormLabel-filled": {
                                      color: "#111827",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      fontFamily: "inherit",
                                    },
                                  },
                                }}
                              />
                            </div>
                          </div>

                          <div className={ProfileStyles.topContainer}>
                            <div className={ProfileStyles.textFeildWrapper}>
                              <div className={ProfileStyles.labeltext}>
                                Occupation
                              </div>
                              <CommonDropdownLatest
                                LabelName="Occupation"
                                menuItems={occupationOptions}
                                name="occupation"
                                value={values.occupation}
                                handleChange={handleChange}
                                error={
                                  touched.occupation &&
                                  Boolean(errors.occupation)
                                }
                                helperText={
                                  touched.occupation && errors.occupation
                                }
                                setOthers={setOthersData}
                              />
                            </div>
                            {isMobile && (
                              <>
                                {occupationOther === "Others" && (
                                  <div
                                    className={ProfileStyles.textFeildWrapper}
                                    style={{
                                      width: "100%",
                                    }}
                                  >
                                    <div className={ProfileStyles.labeltext}>
                                      Occupation Other's
                                    </div>
                                    <TextField
                                      autoComplete="off"
                                      id="outlined-basic"
                                      placeholder="Enter Your Occupation"
                                      variant="outlined"
                                      name="occupationIfOthers"
                                      value={values.occupationIfOthers.toUpperCase()}
                                      error={
                                        touched.occupationIfOthers &&
                                        Boolean(errors.occupationIfOthers)
                                      }
                                      helperText={
                                        touched.occupationIfOthers &&
                                        errors.occupationIfOthers?.toString()
                                      }
                                      className={ProfileStyles.textfield}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      inputProps={{
                                        sx: {
                                          "&::label": {
                                            fill: "#111827",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                          },
                                          color: "#121923",
                                          fontSize: "14px",
                                          "&::placeholder": {
                                            color: "#6B7280",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            opacity: 0.6,
                                          },
                                        },
                                        maxLength: 50,
                                        inputMode: "text",
                                      }}
                                      sx={{
                                        fieldset: {
                                          borderColor: "#E5E7EB",
                                          borderRadius: "100px",
                                        },
                                      }}
                                      InputLabelProps={{
                                        sx: {
                                          color: "#6B7280",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          "&.MuiFormLabel-filled": {
                                            color: "#111827",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            fontFamily: "inherit",
                                          },
                                        },
                                      }}
                                    />
                                    {/* <FormHelperText>
                                {touched.occupationIfOthers &&
                                  errors.occupationIfOthers?.toString()}
                              </FormHelperText> */}
                                  </div>
                                )}
                              </>
                            )}

                            <div className={ProfileStyles.textFeildWrapper}>
                              <div className={ProfileStyles.labeltext}>
                                Trading Experience
                              </div>
                              <CommonDropdownLatest
                                LabelName="Trading Experience"
                                menuItems={tradingExperienceOptions}
                                name="tradingExperience"
                                value={values.tradingExperience}
                                handleChange={handleChange}
                                error={
                                  touched.tradingExperience &&
                                  Boolean(errors.tradingExperience)
                                }
                                helperText={
                                  touched.tradingExperience &&
                                  errors.tradingExperience
                                }
                                setOthers={""}
                              />
                            </div>
                          </div>
                          {!isMobile && (
                            <>
                              {occupationOther === "Others" && (
                                <div className={ProfileStyles.topContainer}>
                                  <div
                                    className={ProfileStyles.textFeildWrapper}
                                    style={{
                                      width: "100%",
                                    }}
                                  >
                                    <div className={ProfileStyles.labeltext}>
                                      Occupation Other's
                                    </div>
                                    <TextField
                                      autoComplete="off"
                                      id="outlined-basic"
                                      placeholder="Enter Your Occupation"
                                      variant="outlined"
                                      name="occupationIfOthers"
                                      value={values.occupationIfOthers.toUpperCase()}
                                      error={
                                        touched.occupationIfOthers &&
                                        Boolean(errors.occupationIfOthers)
                                      }
                                      helperText={
                                        touched.occupationIfOthers &&
                                        errors.occupationIfOthers?.toString()
                                      }
                                      className={ProfileStyles.textfield}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      inputProps={{
                                        sx: {
                                          "&::label": {
                                            fill: "#111827",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                          },
                                          color: "#121923",
                                          fontSize: "14px",
                                          "&::placeholder": {
                                            color: "#6B7280",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            opacity: 0.6,
                                          },
                                        },
                                        maxLength: 50,
                                        inputMode: "text",
                                      }}
                                      sx={{
                                        fieldset: {
                                          borderColor: "#E5E7EB",
                                          borderRadius: "100px",
                                        },
                                      }}
                                      InputLabelProps={{
                                        sx: {
                                          color: "#6B7280",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          "&.MuiFormLabel-filled": {
                                            color: "#111827",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                            fontFamily: "inherit",
                                          },
                                        },
                                      }}
                                    />
                                    {/* <FormHelperText>
                                {touched.occupationIfOthers &&
                                  errors.occupationIfOthers?.toString()}
                              </FormHelperText> */}
                                  </div>
                                </div>
                              )}
                            </>
                          )}

                          <div className={ProfileStyles.topContainer}>
                            <div className={ProfileStyles.textFeildWrapper}>
                              <div className={ProfileStyles.labeltext}>
                                Are You Politically Exposed
                              </div>
                              {isMobile ? (
                                <CommonDropdownLatest
                                  LabelName="Are You Politically Exposed"
                                  menuItems={politicallyExposed}
                                  name="areYouPoliticallyExposed"
                                  value={values.areYouPoliticallyExposed}
                                  handleChange={handleChange}
                                  error={
                                    touched.areYouPoliticallyExposed &&
                                    Boolean(errors.areYouPoliticallyExposed)
                                  }
                                  helperText={
                                    touched.areYouPoliticallyExposed &&
                                    errors.areYouPoliticallyExposed
                                  }
                                  setOthers={""}
                                />
                              ) : (
                                <CommonRadioGroup
                                  LabelName="Are You Politically Exposed"
                                  menuItems={politicallyExposed}
                                  name="areYouPoliticallyExposed"
                                  value={values.areYouPoliticallyExposed}
                                  handleChange={handleChange}
                                  error={
                                    touched.areYouPoliticallyExposed &&
                                    Boolean(errors.areYouPoliticallyExposed)
                                  }
                                  helperText={
                                    touched.areYouPoliticallyExposed &&
                                    errors.areYouPoliticallyExposed
                                  }
                                  setOthers={""}
                                />
                              )}
                            </div>
                            <div className={ProfileStyles.textFeildWrapper}>
                              <div className={ProfileStyles.labeltext}>
                                Marital Status
                              </div>
                              {isMobile ? (
                                <CommonDropdownLatest
                                  LabelName="Marital Status"
                                  menuItems={maritalStatus}
                                  name="maritalStatus"
                                  value={values.maritalStatus}
                                  handleChange={handleChange}
                                  error={
                                    touched.maritalStatus &&
                                    Boolean(errors.maritalStatus)
                                  }
                                  helperText={
                                    touched.maritalStatus &&
                                    errors.maritalStatus
                                  }
                                  setOthers={""}
                                />
                              ) : (
                                <CommonRadioGroup
                                  LabelName="Marital Status"
                                  menuItems={maritalStatus}
                                  name="maritalStatus"
                                  value={values.maritalStatus}
                                  handleChange={handleChange}
                                  error={
                                    touched.maritalStatus &&
                                    Boolean(errors.maritalStatus)
                                  }
                                  helperText={
                                    touched.maritalStatus &&
                                    errors.maritalStatus
                                  }
                                  setOthers={""}
                                />
                              )}
                            </div>
                          </div>
                          <div className={ProfileStyles.topContainer}>
                            <div
                              className={ProfileStyles.textFeildWrapper}
                              style={{ width: "100%" }}
                            >
                              <div className={ProfileStyles.labeltext}>
                                Annual Income
                              </div>
                              {isMobile ? (
                                <CommonDropdownLatest
                                  LabelName="Annual Income"
                                  menuItems={annualIncomeOptions}
                                  name="annualIncome"
                                  value={values.annualIncome}
                                  handleChange={handleChange}
                                  error={
                                    touched.annualIncome &&
                                    Boolean(errors.annualIncome)
                                  }
                                  helperText={
                                    touched.annualIncome && errors.annualIncome
                                  }
                                  setOthers={""}
                                />
                              ) : (
                                <CommonRadioGroup
                                  LabelName="Annual Income"
                                  menuItems={annualIncomeOptions}
                                  name="annualIncome"
                                  value={values.annualIncome}
                                  handleChange={handleChange}
                                  error={
                                    touched.annualIncome &&
                                    Boolean(errors.annualIncome)
                                  }
                                  helperText={
                                    touched.annualIncome && errors.annualIncome
                                  }
                                  setOthers={""}
                                />
                              )}
                            </div>
                          </div>

                          <div className={ProfileStyles.otherBrokersSection}>
                            <div
                              className={ProfileStyles.otherBrokersText}
                              onClick={() => {
                                setExpandOthers(!expandOthers);
                              }}
                            >
                              Previous Dealings with Other Brokers{" "}
                              <ArrowDropDownIcon
                                style={{ fontSize: "30px", marginTop: "-4px" }}
                              />
                            </div>

                            <div
                              className={ProfileStyles.bottomFeilds}
                              style={{
                                maxHeight: expandOthers ? "400px" : "0px",
                                paddingTop: expandOthers ? "32px" : "0px",
                              }}
                            >
                              <div className={ProfileStyles.textFeildWrapper}>
                                <div className={ProfileStyles.labeltext}>
                                  Past Actions (Optional)
                                </div>
                                {displayFatherNameField && (
                                  <TextField
                                    autoComplete="off"
                                    className={ProfileStyles.textfield}
                                    id="outlined-basic"
                                    // label="Father's Name"
                                    placeholder="Provide details of SEBI, Stock Exchange, or other authority proceedings (in last 3 years)"
                                    variant="outlined"
                                    name="fatherFullName"
                                    value={pastActions}
                                    onChange={(event: any) => {
                                      setPastActions(event.target.value);
                                    }}
                                    inputProps={{
                                      sx: {
                                        "&::label": {
                                          fill: "#111827",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        },
                                        color: "#121923",
                                        fontSize: "14px",
                                        "&::placeholder": {
                                          color: "#6B7280",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          opacity: 0.6,
                                        },
                                      },
                                      maxLength: 50,
                                      inputMode: "text",
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        // marginTop:"2px",
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          fontFamily: "inherit",
                                        },
                                      },
                                    }}
                                  />
                                )}
                              </div>

                              <div className={ProfileStyles.textFeildWrapper}>
                                <div className={ProfileStyles.labeltext}>
                                  Dealings with other broker (Optional)
                                </div>
                                <TextField
                                  autoComplete="off"
                                  className={ProfileStyles.textfield}
                                  id="outlined-basic"
                                  // label="Mother's Name"
                                  placeholder="Enter other broker details, client code, exchanges, and disputes"
                                  variant="outlined"
                                  name="motherFullName"
                                  value={otherBrokers}
                                  onChange={(event: any) => {
                                    setOtherBrokers(event.target.value);
                                  }}
                                  inputProps={{
                                    sx: {
                                      "&::label": {
                                        fill: "#111827",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                      },
                                      color: "#121923",
                                      fontSize: "14px",
                                      "&::placeholder": {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        opacity: 0.6,
                                      },
                                    },
                                    maxLength: 50,
                                    inputMode: "text",
                                  }}
                                  sx={{
                                    fieldset: {
                                      borderColor: "#E5E7EB",
                                      borderRadius: "100px",
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      color: "#6B7280",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      "&.MuiFormLabel-filled": {
                                        color: "#111827",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                        fontFamily: "inherit",
                                      },
                                    },
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <ErrorSnackBar message={rejectMessage} />
                          {backdrop && <StartOverBackDrop />}
                          <div className={ProfileStyles.buttonStack}>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {values.areYouPoliticallyExposed &&
                              values.fatherFullName &&
                              values.motherFullName &&
                              values.annualIncome &&
                              values.occupation &&
                              values.maritalStatus &&
                              values.tradingExperience &&
                              // values.settlements &&
                              (values.occupation.value === "Others"
                                ? Boolean(values.occupationIfOthers)
                                : true) &&
                              !errors.fatherFullName &&
                              !errors.motherFullName ? (
                                <LoadingButton
                                  loading={loading}
                                  variant="contained"
                                  type="submit"
                                  id="yourProfileContinueButton"
                                  onClick={() => {
                                    handleSubmit();
                                  }}
                                  className={ProfileStyles.approveButton}
                                  sx={{ height: "50px" }}
                                >
                                  Continue
                                </LoadingButton>
                              ) : (
                                <Button
                                  variant="contained"
                                  disabled
                                  onClick={() => {
                                    handleSubmit();
                                  }}
                                  className={ProfileStyles.approveButton}
                                  sx={{ height: "50px" }}
                                >
                                  Continue
                                </Button>
                              )}
                            </div>
                            {/* <div className={ProfileStyles.startOverSection}>
                          <img src={icon} className={ProfileStyles.iconImage} />
                          <p className={ProfileStyles.paratext}>
                            {" "}
                            if the above mentioned info not yours
                            <span
                              className={ProfileStyles.startoverbutton}
                              onClick={handleStartOver}
                            >
                              Start Over
                            </span>
                          </p>
                        </div> */}
                          </div>
                        </div>
                      </form>
                    );
                  }}
                </Formik>
              ) : (
                <div style={{ height: "80vh" }}>
                  <BackDrop />
                </div>
              )}
            </div>
          </div>
        </>

        <PloiticalModal openModal={openModal} handleDone={handleDone} />
      </div>
    </>
  );
}
